module.exports = __webpack_public_path__ + "img/tuanjian3.fab33b60.png";